import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Import flags as React components or images
import enFlag from '../flags/en.svg';
import deFlag from '../flags/de.svg';
import arFlag from '../flags/sa.svg';  // Arabic uses Saudi Arabia flag svg
import trFlag from '../flags/tr.svg';

import '../styles/LanguageSwitcher.css';

const languages = [
    { code: 'en', name: 'English', flag: enFlag },
    { code: 'de', name: 'Deutsch', flag: deFlag },
    { code: 'ar', name: 'العربية', flag: arFlag },
    { code: 'tr', name: 'Türkçe', flag: trFlag },
];

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();
    const [open, setOpen] = useState(false);
    const switcherRef = useRef(null);

    // Close dropdown if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (switcherRef.current && !switcherRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const currentLang = languages.find(lang => lang.code === i18n.language) || languages[0];

    const handleSelect = (code) => {
        i18n.changeLanguage(code);
        document.documentElement.setAttribute('dir', code === 'ar' ? 'rtl' : 'ltr');
        setOpen(false);
    };

    return (
        <div className="language-switcher" ref={switcherRef}>
            <button
                className="language-switcher__button"
                onClick={() => setOpen(!open)}
                aria-haspopup="listbox"
                aria-expanded={open}
            >
                <img src={currentLang.flag} alt={`${currentLang.name} flag`} className="language-switcher__flag" />
                <span className="language-switcher__name">{currentLang.name}</span>
                <span className={`language-switcher__arrow ${open ? 'open' : ''}`}>&#9662;</span>
            </button>
            {open && (
                <ul className="language-switcher__list" role="listbox" tabIndex={-1}>
                    {languages.map(lang => (
                        <li
                            key={lang.code}
                            className={`language-switcher__item ${lang.code === currentLang.code ? 'selected' : ''}`}
                            onClick={() => handleSelect(lang.code)}
                            role="option"
                            aria-selected={lang.code === currentLang.code}
                        >
                            <img src={lang.flag} alt={`${lang.name} flag`} className="language-switcher__flag" />
                            <span className="language-switcher__name">{lang.name}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default LanguageSwitcher;
